import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorDisplayComponent } from './errorDisplay.component';
import { TranslateModule } from '@ngx-translate/core';
import { ContainerModule } from '@app/components/container/container.module';
import { HomeSectionModule } from '@app/home/homeSection/homeSection.module';
import { ButtonModule } from '@app/components/button/button.module';

@NgModule({
  imports: [CommonModule, TranslateModule, ContainerModule, HomeSectionModule, ButtonModule],
  declarations: [ErrorDisplayComponent],
  exports: [ErrorDisplayComponent],
})
export class ErrorDisplayModule {}
